module.exports = __webpack_public_path__ + "static/media/cartArrow.72280b51.svg";